import React from 'react';
import pathStore from '../../../store/pathStore';
import treeStore from '../../../store/treeStore';
import { Popover, OverlayTrigger, ButtonToolbar, Button } from 'react-bootstrap';
import { deleteTree } from '../../../action/treeAction';
import Dotdotdot from 'react-clamp';
import { FaPlus, FaPencilAlt, FaMinus, FaHome, FaGlobe, FaCloud, FaFile, FaFolderOpen, FaSearchPlus } from 'react-icons/fa';



/**This is the entity which renders out onto the screen
 * it also builds its own children
 * recursive component 
 */
function TreeEntity(props) {
    let childMapper = [];
    let childMap = [];
    let typeOfChildren = [];
    let mapDiv, overLay, popover;
    let hasChildren = false;
    // let tree = Object.entries(treeStore.tree);
    let classCss = `Tree-entity ${props.type}`;
    let childContainer = 'childContainer';
    let clickable = true;
    if (props.id !== "0") {
        if (pathStore.relationship) {
            let relationTree = Object.entries(pathStore.relationship);
            relationTree.forEach((element => {
                if (element[1].parent === props.id) {
                    element[1].children.forEach((child => {
                        childMap.push({ child });
                        if (treeStore.tree[child]) {
                            typeOfChildren.push(treeStore.tree[child].type);
                        }
                    }));
                }
            }));
            hasChildren = true;
        }
        if (childMap.length >= 1) {
            childMap.forEach((element => {
                if (treeStore.tree[element.child]) {
                    //Need to add a new type, dont forget to add it in here
                    if (treeStore.tree[element.child].type === "docLib" || treeStore.tree[element.child].type === "page") {
                        childMapper.push(treeStore.tree[element.child]);
                    } else if (treeStore.tree[element.child].type === "site" || treeStore.tree[element.child].type === "hub") {
                        childMapper.unshift(treeStore.tree[element.child]);
                    }
                }
            }));
        }
        if (childMapper) {
            childMap = childMapper.map((list => {
                /**Adding more data to a node, then add here this is so it can be passed through to the modal*/
                return (
                    <TreeEntity key={list.id} id={list.id} name={list.name} children={list.children} templateId={list.templateId}
                        addEvent={props.addEvent} type={list.type} shortName={list.shortName} sources={list.sources} theme={list.theme}
                        notes={list.notes} flatten={list.flatten} looseFiles={list.looseFiles} readOnly={props.readOnly}
                    />
                );
            }));
        }

        /* Renders things differently for certain children TODO maybe put 'Libraries' stub object here? Issue #9 */
        if (hasChildren) {
            let childType = "tree-children";
            //checks if theres anything other than docLibs
            const types = typeOfChildren.filter((children) => {
                if (children === "docLib" || children === "page") {
                    return false;
                }
                return true;
                // return children !== "docLib" || children !== "page";
            });
            //if so its not going down
            if (types.length === 0) {
                childType += " docLib";
            }
            // childType += props.type === 'site' ? ' docLib' : '';
            mapDiv = (
                <div className={childType}>
                    {childMap}
                </div>
            );
        }
    }
    let addClick = function () {
        popover.hide();
        props.addEvent(props.id);
    };
    let editClick = function () {
        /**if you want to add objects to the modal add them to the editObj */
        let editObj = {
            edit: true,
            name: props.name,
            shortName: props.shortName,
            sources: props.sources,
            notes: props.notes,
            flatten: props.flatten,
            looseFiles: props.looseFiles,
            id: props.id,
            type: props.type,
            templateId: props.templateId,
            theme: props.theme
        };
        popover.hide();
        props.addEvent(editObj);
    };
    let deleteClick = function () {
        popover.hide();
        deleteTree(props.id);
    };
    if (props.readOnly) {
        if (props.id === "0") {
            clickable = false;
        } else {
            overLay = (
                <Popover id="popover-trigger-focus" title={`${props.type} Toolbar`} className="text-center text-capitalize">
                    <Button onClick={editClick}>
                        <FaSearchPlus />
                    </Button>
                </Popover>
            );
        }
    } else {
        if (props.type === "hub") {
            overLay = (
                <Popover id="popover-trigger-focus" title="Hub Toolbar" className="text-center">
                    <ButtonToolbar>
                        <Button onClick={addClick}>
                            <FaPlus />
                        </Button><span>&nbsp;</span>
                        <Button onClick={editClick}>
                            <FaPencilAlt />
                        </Button><span>&nbsp;</span>
                        <Button onClick={deleteClick}>
                            <FaMinus />
                        </Button><span>&nbsp;</span>
                    </ButtonToolbar>
                </Popover>
            );
        } else if (props.type === "docLib") {
            overLay = (
                <Popover id="popover-trigger-focus" title="Doc Library Toolbar" className="text-center" >
                    {/* <ButtonToolbar > */}
                    <Button onClick={editClick}>
                        <FaPencilAlt />
                    </Button><span>&nbsp;</span>
                    <Button onClick={deleteClick}>
                        <FaMinus />
                    </Button><span>&nbsp;</span>
                    {/* </ButtonToolbar> */}
                </Popover>
            );
        } else if (props.type === "root") {
            overLay = (
                <Popover id="popover-trigger-focus" title="Root Toolbar" className="text-center">
                    {/* <ButtonToolbar className="text-center"> */}
                    <Button onClick={addClick}>
                        <FaPlus />
                    </Button><span>&nbsp;</span>
                    <Button onClick={deleteClick}>
                        <FaMinus />
                    </Button><span>&nbsp;</span>
                    {/* </ButtonToolbar> */}
                </Popover>
            );
        } else if (props.type === "site") {
            overLay = (
                <Popover id="popover-trigger-focus" title="Site Toolbar" className="text-center">
                    <ButtonToolbar>
                        <Button onClick={addClick}>
                            <FaPlus />
                        </Button><span>&nbsp;</span>
                        <Button onClick={editClick}>
                            <FaPencilAlt />
                        </Button><span>&nbsp;</span>
                        <Button onClick={deleteClick}>
                            <FaMinus />
                        </Button><span>&nbsp;</span>
                    </ButtonToolbar>
                </Popover>
            );
        } else if (props.type === "page") {
            overLay = (
                <Popover id="popover-trigger-focus" title="Page Toolbar" className="text-center" >
                    {/* <ButtonToolbar > */}
                    <Button onClick={editClick}>
                        <FaPencilAlt />
                    </Button><span>&nbsp;</span>
                    <Button onClick={deleteClick}>
                        <FaMinus />
                    </Button><span>&nbsp;</span>
                    {/* </ButtonToolbar> */}
                </Popover>
            );
        }
    }

    let iconChooser = (entityType) => {
        switch (entityType) {
            case 'root':
                return (<FaHome />);
            case 'hub':
                return (<FaGlobe />);
            case 'site':
                return (<FaCloud />);
            case 'docLib':
                return (<FaFolderOpen />);
            case 'page':
                return (<FaFile />);
            default:
                return '';
        }
    };
    return (
        <div className={childContainer}>
            {clickable ? <OverlayTrigger trigger="click" placement="bottom" overlay={overLay} ref={input => popover = input}>
                <div className={classCss} id={props.id}>
                    <span className="entityIcon">{iconChooser(props.type)}</span>
                    <Dotdotdot clamp={2}>
                        <p title={props.name}>
                            {props.name}
                        </p>
                    </Dotdotdot>
                </div>
            </OverlayTrigger>
                : <div className={classCss} id={props.id}>
                    <span className="entityIcon">{iconChooser(props.type)}</span>
                    <Dotdotdot clamp={2}>
                        <p title={props.name}>
                            {props.name}
                        </p>
                    </Dotdotdot>
                </div>
            }

            {mapDiv}
        </div>
    );
}

// function clicker(){}
export default TreeEntity;



// WEBPACK FOOTER //
// ./src/components/tree/node/treeEntity.js